<template>
  <div v-if="tourneeModele">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ getTitle(false) }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button"
               @click="$router.go(-1)">
              {{ $t('addEditTourneeModele.actions.cancel') }}
            </a>
            <a class="button is-addOrEdit" @click="save">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         :title="'addEditTourneeModele.errors.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="columns is-multiline">
      <div class="column is-12 mgt-20px">
        <information-tournee-modele
        :tourneeModele="tourneeModele">
        </information-tournee-modele>
      </div>
      <div class="column is-12 mgt-20px"  v-if="messagesInfoStore.length">
        <qd-collapse :open="openDetail"
          class="message is-danger">
          <div
            slot="trigger"
            slot-scope="props"
            class="columns is-marginless pdv-0 is-vcentered
              is-justify-content-space-between message-header"
            role="button">
            <div class="column is-narrow pdl-0 columns is-marginless">
              <a>
                <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"/>
              </a>
            </div>
            <div class="column is-narrow pdl-0 columns is-marginless">
              <span v-if="messagesInfoStore.length > 1">
              {{$t('addEditTourneeModele.facesNotAddListeAffichage.titleMulti',
                {nbreFaces: messagesInfoStore.length})}}
              </span>
              <span v-else>
                {{$t('addEditTourneeModele.facesNotAddListeAffichage.titleSingle')}}
              </span>
            </div>
            <div class="column">
            </div>
            <div class="column is-narrow">
              <a @click="closeMessage">
                <b-icon icon="close-circle"/>
              </a>
            </div>
          </div>
          <div class="message-body border-none">
            <div class="content">
              <b-table :data="messagesInfoStore" :bordered="true" :striped="true">
                <b-table-column
                  header-class="has-text-default"
                  field="codeFace"
                  v-slot="props"
                  :label="$t('addEditTourneeModele.facesNotAddListeAffichage.tab.codeFace')">
                  {{ props.row.codeFace }}
                </b-table-column>
                <b-table-column
                  header-class="has-text-default"
                  field="motif"
                  v-slot="props"
                  :label="$t('addEditTourneeModele.facesNotAddListeAffichage.tab.motif')">
                  {{ props.row.motif }}
                </b-table-column>
              </b-table>
            </div>
          </div>
        </qd-collapse>
      </div>
      <div class="column is-12 mgt-20px">
        <faces-reseaux-associes
          :tourneeModele="tourneeModele">
        </faces-reseaux-associes>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get, update, create } from '@/api/logistique/tourneeModele/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import genererTourneeModele from '@/services/logistique/tourneeModele/genererTourneeModele';
import breadcrumb from '@/components/general/breadcrumb';
import informationTourneeModele
  from '@/components/logistique/tourneeModele/addEdit/informationTourneeModele';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import facesReseauxAssocies
  from '@/components/logistique/tourneeModele/addEdit/facesReseauxAssocies';
import { getAll } from '@/api/gabed/face/index';
import { addInformationsOfFacesInLignes } from '@/services/logistique/tourneeModele/addInformationPatrimonialTourneeLigne';
import validation from '@/services/validation/validation';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAffectationRegroupement } from '@/api/produit/produitFace';
import formatIsoDate from '@/services/general/formatIsoDate';
import translate from '@/services/logistique/tourneeModele/translatorTourneeModele';
import { SET_TOURNEE_MODELE, SET_MESSAGE_INFO } from '@/store/modules/logistique/tourneeModele-mutation-type';
import validationTourneeModele from '@/services/logistique/tourneeModele/validation';

const societe = createNamespacedHelpers('societe');
const TourneeModele = createNamespacedHelpers('tourneeModele');

export default {
  data() {
    return {
      tourneeModele: null,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      openDetail: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    informationTourneeModele,
    errorMsgComponent,
    facesReseauxAssocies,
  },
  computed: {
    ...TourneeModele.mapGetters({
      tourneeModeleStored: 'tourneeModele',
      messagesInfoStore: 'messagesInfoAjoutFaces',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    breadcrumb() {
      return [
        { title: this.$t('addEditTourneeModele.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditTourneeModele.breadcrumb.liste'), route: { name: 'l.logistique.tournee_modele' }, isActive: false },
        { title: this.getTitle(true), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    ...TourneeModele.mapMutations({
      setTournee: SET_TOURNEE_MODELE,
      setMessageInfo: SET_MESSAGE_INFO,
    }),
    getTitle(isBreadcrumbAndEditRoute) {
      if (this.$route.params.id) {
        if (isBreadcrumbAndEditRoute) {
          return this.$i18n.t('addEditTourneeModele.title.breadcrumbEdit');
        }
        return this.$i18n.t('addEditTourneeModele.title.edit', { nom: this.tourneeModele.libelle });
      }
      return this.$i18n.t('addEditTourneeModele.title.add');
    },
    async getPatrimonialFaceInformation(tourneeModele) {
      const params = {
        query: {
          ids: tourneeModele.tourneeLignes.map((tournee) => { return tournee.faceId; }),
          societeId: this.societeActiveId,
          nonCommercialisable: null,
        },
        limit: NO_PAGINATION,
      };
      return (await getAll(params)).data.result.items;
    },
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let tourneeModele;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.error = false;
        if (this.$route.params.id) {
          tourneeModele = (await update(this.tourneeModele)).data.result;
          messageSuccess(this.$t('addEditTourneeModele.success.edit'));
        } else {
          tourneeModele = (await create(this.tourneeModele)).data.result;
          messageSuccess(this.$t('addEditTourneeModele.success.add'));
        }
        await this.$router.push(({ name: 'c.logistique.tournee_modele', params: { id: tourneeModele.id } }));
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationTourneeModele(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    closeMessage() {
      this.setMessageInfo([]);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.tourneeModeleStored) {
        this.tourneeModele = this.tourneeModeleStored;
        this.setTournee(null);
        loadingComponent.close();
        return;
      }
      if (this.$route.params.id) {
        const tourneeModele = (await get(this.$route.params.id)).data.result;
        let patrimonialFaceInformation = [];
        const faceIds = tourneeModele.tourneeLignes
          .map(tournee => tournee.faceId).filter(faceId => faceId);
        if (faceIds.length) {
          patrimonialFaceInformation = await this.getPatrimonialFaceInformation(tourneeModele);
          const reseauInformation = (await getAffectationRegroupement({
            dateVisu: formatIsoDate(new Date()),
            produitIds: patrimonialFaceInformation
              .filter(patrimonialFace => patrimonialFace.produitId)
              .map((patrimonialFace) => patrimonialFace.produitId),
          })).data.result;

          addInformationsOfFacesInLignes(patrimonialFaceInformation, tourneeModele.tourneeLignes,
            reseauInformation);
        }
        tourneeModele.tourneeLignes.sort((a, b) => {
          return a.ordre - b.ordre;
        });
        this.tourneeModele = tourneeModele;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.tourneeModele.libelle }));
      } else {
        this.setInformationPage(this.$t('pageLogistique.tourneeModele.creation'));
        this.tourneeModele = genererTourneeModele();
        if (this.agenceActive.length === 1) {
          this.tourneeModele.agenceId = this.agenceActive[0].agenceId;
        }
        this.setMessageInfo([]);
      }
      this.tourneeModele.societeId = this.societeActiveId;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
